module.exports = __webpack_public_path__ + "static/media/tgle-almazen.eccda8d1.png";